export default "__VITE_ASSET__BfUeciIo__"